// <SeatSheet> — tap another player's seat (when the tap isn't a vote): who they are, 🚩 Report and 🙈 Block
// (src/safety.mjs; App Store guideline 1.2). A block hides their chat for you and keeps you apart in matchmaking.
// Opened by the classic showSeatMenu → app.seatMenu = {id, step}; the seat-* actions run through the document-level
// click delegation like every other overlay. PURE function of `app`.
import { html, t } from '../shared.js';

const REASONS = ['offensive', 'cheating', 'spam', 'other'];

export function SeatSheet({ app }: { app: AppState }) {
  const m: any = (app as any).seatMenu;
  const r: any = app && app.room;
  if (!m || !r) return '';
  const p: any = (r.players || []).find((x: Player) => x.id === m.id);
  if (!p) return '';
  const blocked = ((r.me && r.me.blocked) || []).includes(p.id);
  const kind = p.type === 'agent' ? (p.owner ? t('seat.agentBadge', { owner: p.owner }) : t('seat.agentUnclaimed')) : t('seat.menu.player');
  return html`
    <div class="overlay seatmenu-overlay"><div class="sheet seatmenu-sheet">
      <div class="seatmenu-who"><span class="seatmenu-em">${p.emoji || '🧑'}</span><div><div class="seatmenu-name">${p.name}</div><div class="muted seatmenu-kind">${kind}</div></div></div>
      ${blocked ? html`<p class="muted seatmenu-note">${t('seat.menu.blockedNote')}</p>` : ''}
      ${m.step === 'reasons'
        ? html`<div class="seatmenu-h">${t('seat.menu.reasonsTitle')}</div>
               <div class="seatmenu-col">${REASONS.map(k => html`<button class="ghost" key=${k} data-action="seat-report-reason" data-reason=${k}>${t('seat.menu.reason.' + k)}</button>`)}</div>`
        : html`<div class="seatmenu-col">
                 <button class="ghost" data-action="seat-report">${t('seat.menu.report')}</button>
                 <button class="ghost" data-action="seat-block">${blocked ? t('seat.menu.unblock') : t('seat.menu.block')}</button>
               </div>`}
      <button class="ghost seatmenu-close" data-action="seat-menu-close">${t('seat.menu.close')}</button>
    </div></div>
  `;
}
